import { EntityModel } from '@/interfaces'
import {
  ALL_ROOM_TYPES_QUERY,
  CREATE_ROOM_TYPE_MUTATION,
  DELETE_ROOM_TYPE_MUTATION,
  FORCE_DELETE_ROOM_TYPE_MUTATION,
  SINGLE_ROOM_TYPE_QUERY,
  UPDATE_ROOM_TYPE_MUTATION,
} from './graphql'
import imageGalleryEntity from '@/entities/imageGallery/entity'

const accommodationRoomTypeModel: EntityModel = {
  name: 'roomType',
  namePlural: 'roomTypes',
  uniqueName: 'accommodationRoomType',
  uniqueNamePlural: 'accommodationRoomTypes',
  path: 'travel/accommodation/room_type',
  baseUrl: '/travel/accommodation/room_types',
  translationPrefix: 'entities:accommodationRoomType.',
  getDisplayName: (values: any) => {
    return values.name
  },
  gql: {
    getAll: ALL_ROOM_TYPES_QUERY,
    getSingle: SINGLE_ROOM_TYPE_QUERY,
    create: CREATE_ROOM_TYPE_MUTATION,
    update: UPDATE_ROOM_TYPE_MUTATION,
    delete: DELETE_ROOM_TYPE_MUTATION,
    forceDelete: FORCE_DELETE_ROOM_TYPE_MUTATION,
  },
  attributes: {
    name: {
      name: 'name',
      label: 'entities:accommodationRoomType.attributes.name.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    description: {
      name: 'description',
      label: 'entities:accommodationRoomType.attributes.description.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'wysiwyg',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    gallery: {
      name: 'gallery',
      label: 'entities:accommodationRoomType.attributes.gallery.label',
      type: 'entityObject',
      dataType: 'any',
      getEntity: () => {
        return imageGalleryEntity
      },
      defaultInput: false,
      inputType: 'select',
      validationType: 'string',
      validations: [],
    },
  },
}

export default accommodationRoomTypeModel
